import { appInfo } from "./appInfo";
import { successStatus } from './constants'
const NEW_VWA_SDK_MIN_VERSION = "4.3.0"
const NEW_SVW_SDK_MIN_VERSION = "4.8.0"
const NEW_LEXUS_SDK_MIN_VERSION = "2.0.0"
const NEW_RHINOS_MIN_VERSION = "1.0.0"
const NEW_DPCA_MIN_VERSION = "1.0.0"
// const NEW_CHENGQU_MIN_VERSION = "4.1.3" // 暂时不用
const NEW_TIKA_MIN_VERSION = "4.1.3"
const NEW_LX_MIN_VERSION = "4.1.3"
const DPCA_APP_NAV_VERSION = "0.0.0";
const DPCA_PEUGEO_NAV_VERSION = "0.0.0";
const VWSDK_HARMONY_VERSION = "2.0.0";
const DPCA_HARMONY_VERSION = "2.0.0";
const DPCA_PEUGEO_HARMONY_VERSION = "2.0.0";


const OLD_BRIDGE_FUNCTION = ["doShare", "createApiRequest", "shareUrlToWechat", "doSaveLocalImg", "doCustomShare", "getUserInfo", "getCurrentVehicleDetailInfo", "setNativeHeader", "getSystemInfo", "saveImageToPhotoAlbum"]
function isStr(str: string) {
  return typeof str === 'string'
}

function isObject(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
type ProxyF = {
  android: (...args: any[]) => any;
  ios: (...args: any[]) => any;
};
// const oldJsQuene = []
export function compareVersion(appVerionOne: string, appVersionTwo: string): boolean | Error {
  if (!isStr(appVerionOne) || !isStr(appVersionTwo)) {
    return new Error('请传入正确的字符串');
  }
  const verOneArr = appVerionOne.split('.')
  const verTwoArr = appVersionTwo.split('.')
  const maxLength = Math.max(verOneArr.length, verTwoArr.length)
  let i = 0
  while (i < maxLength) {
    const v1Num = Number(verOneArr[i])
    const v2Num = Number(verTwoArr[i])
    i++
    if (v1Num > v2Num) {
      return true
    }
    if (v1Num < v2Num) {
      return false
    }
    if (v1Num === v2Num) continue
  }
  return true
}


export function getQueryParams(data: { [prop: string]: any }) {
  if (!isObject(data)) {
    return ''
  }
  const strArr: string[] = []
  Object.keys(data).forEach(item => {
    if(isObject(data[item])){
      data[item] = JSON.stringify(data[item])
    }
    strArr.push(`${item}=${data[item]}`)
  })
  return strArr.join('&')
}


interface CallbackOption {
  count: number; // 回调次数
};

export type CallbackFunction = (res?: any, option?: CallbackOption) => void;



/**
 * 本地回调函数
 * @param res 
 */
export function formatNativeParam(res: any) {
  const data = osProxy({
    android: () => {
      if (typeof res === 'object') {
        return res;
      }
      if (!res) {
        return { success: true }
      }
      if (res.indexOf('{') === 0) {
        try {
          return JSON.parse(res)
        } catch (err) {
          return { success: true, data: res }
        }
      }
      return { success: true, data: res }
    },
    ios: () => {
      if (res) {
        return JSON.parse(res);
      }
      return { code: 404 }
    }
  });
  return data;
};


/**
 * ios 工厂函数
 * @param url 
 */
export function iosFactoryFn(url: string): void {
  const _window: any = window
  const messageHandlers = _window.webkit && _window.webkit.messageHandlers ? _window.webkit.messageHandlers : {}
  const IngeekJSAPI = messageHandlers.IngeekJSAPI || null
  if (IngeekJSAPI && IngeekJSAPI.postMessage) {
    // 新版通过 postMessage 通信，优化性能
    const arr = url.split('&')
    const method: string = arr.shift() || ''
    let params = {}
    let callbackName = ''
    for (const item of arr) {
      const arr1 = item.split('=')
      const key = arr1[0]
      const value = arr1[1] || ''
      if (key === 'callback') {
        callbackName = value
      } else if (key === 'param') {
        const val = decodeURIComponent(value)
        params = val[0] === '{' ? JSON.parse(val) : val
      }
    }
    IngeekJSAPI.postMessage({
      method,
      params,
      callbackName
    })
  }
};
/**
 * 生成随机回调函数
 * @param fn 回调函数，第二个参数为系统参数 count：当前是第几次回调
 * @param callbackNum 最大回调次数，某些特定场景可以指定多次回调
 */
export function createCallBack(fn: CallbackFunction, maxCallbackNum = 1): string {
  const mathRandom = Math.ceil(Math.random() * 1000);
  const callBackName = `ingeekNativeCallBack${new Date().getTime()}${mathRandom}`;
  const _window: any = window
  if (!_window.nativeCallback) {
    _window.nativeCallback = {}
  }
  _window.nativeCallback[callBackName] = {
    max: maxCallbackNum,
    current: 0
  };
  _window[callBackName] = (res: any) => {
    _window.nativeCallback[callBackName].current++;
    fn(formatNativeParam(res), { count: _window.nativeCallback[callBackName].current });
    if (_window.nativeCallback[callBackName].current >= _window.nativeCallback[callBackName].max) {
      removeCallback(callBackName);
    }
  }
  return callBackName;
};

/**
 * 清除回调函数
 * @param callBackName 
 */
export function removeCallback(callBackName: string) {
  const _window: any = window
  if (_window.nativeCallback) {
    delete _window.nativeCallback[callBackName];
  }
  delete _window[callBackName];
}


export function dealCallBackName(callBack: (...args: any[]) => any) {
  const originCallBack = callBack
  const newCallBack = (res: any) => {
    if (res && res.code !== successStatus) {
      console.error(res.message)
    }
    originCallBack(res || {})
  }
  return newCallBack
}
// version是一个数组
// version[0]是乘趣
// version[1]是上汽大众SDK
// version[2]是大众安徽SDK
// version[3]是LEXUSSDK
export function osProxy(f: ProxyF, data?: any, method?: string, version?: any, callback?: (...args: any[]) => any) {
  if (!appInfo.isAppWebview) {
    const data = {
      code: 404,
      message: '非客户端环境下暂不支持'
    }
    callback && callback({
      code: 404,
      message: '非客户端环境下暂不支持'
    })
    console.warn(data.message)
  } else {
    if (version) {
      const minNokeyAPP = version[0] || '0.0.0'
      const minSVWSdk = version[1] || '0.0.0'
      const minVWASdk = version[2] || '0.0.0'
      const minLexusSdk = version[3] || '0.0.0'
      const minRhinoSdk = version[4] || '0.0.0'
      const minDpcaSdk = version[5] || '0.0.0'
      const defaultMinVersion = '0.0.0'
      if(appInfo.isChengQu) {
        void 0
      } // 可有可无
      if (appInfo.isNokey) {
        console.error(appInfo.version, 'nokey版本')
        if (!compareVersion(appInfo.version, NEW_SVW_SDK_MIN_VERSION) ) {
          if (method && window.ingeekJSApi.common) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return window.ingeekJSApi.common[method](data, callback)
            }
          }
          callback && callback({
            code: 404,
            message: '客户端啥也没实现，两个容器~'
          })
          return
        } else if (!compareVersion(appInfo.version, minNokeyAPP)) {
          console.warn(`当前版本过低，最低版本为${minNokeyAPP}`)
          return
        }
      }
      if (appInfo.isSVWSDK) {
        if (!compareVersion(appInfo.version, NEW_SVW_SDK_MIN_VERSION)) {
          console.error("method", method)
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              console.error(window.ingeekJSApi.common)
              window.ingeekJSApi.common.handleEvent({url: 'app://event/getSystemInfo'},(resizeBy: any)=>{console.error(resizeBy)})
              console.error(paramsStr, 'paramsStr', method,  `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, minSVWSdk)) {
          console.warn(`当前版本过低，最低版本为${minNokeyAPP}`)
          return
        }
      }
      if (appInfo.isVWASDK) {
        if (!compareVersion(appInfo.version, NEW_VWA_SDK_MIN_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, minVWASdk)) {
          console.warn(`当前版本过低，最低版本为${minNokeyAPP}`)
          return
        }
      }
      if (appInfo.isTika) {
        if (!compareVersion(appInfo.version, NEW_TIKA_MIN_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, minNokeyAPP)) {
          console.warn(`当前版本过低，最低版本为${minNokeyAPP}`)
          return
        }
      }
      if (appInfo.isLX) {
        if (!compareVersion(appInfo.version, NEW_LX_MIN_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        } else if (!compareVersion(appInfo.version, minNokeyAPP)) {
          console.warn(`当前版本过低，最低版本为${minNokeyAPP}`)
          return  
        }
      }
      if (appInfo.isRhinos) {
        if (!compareVersion(appInfo.version, NEW_RHINOS_MIN_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        } else if (!compareVersion(appInfo.version, minNokeyAPP)) {
          console.warn(`当前版本过低，最低版本为${minNokeyAPP}`)
          return  
        }
      }
      if (appInfo.isDpca) {
        if (!compareVersion(appInfo.version, NEW_DPCA_MIN_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        } else if (!compareVersion(appInfo.version, minDpcaSdk)) {
          console.warn(`当前版本过低，最低版本为${minDpcaSdk}`)
          return  
        }
      }
      if (appInfo.isLexusSDK) {
        if (!compareVersion(appInfo.version, NEW_LEXUS_SDK_MIN_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, minLexusSdk)) {
          console.warn(`当前版本过低，最低版本为${minLexusSdk}`)
          return
        }
      }
      if (appInfo.isSVWHarmonySDK) {
        if (!compareVersion(appInfo.version, VWSDK_HARMONY_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, defaultMinVersion)) {
          console.warn(`当前版本过低，最低版本为${defaultMinVersion}`)
          return
        }
      }
      if (appInfo.isDpcaHarmonySDK) {
        if (!compareVersion(appInfo.version, DPCA_HARMONY_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, defaultMinVersion)) {
          console.warn(`当前版本过低，最低版本为${defaultMinVersion}`)
          return
        }
      }
      if (appInfo.isDpcaPeugeoHarmonySDK) {
        if (!compareVersion(appInfo.version, DPCA_PEUGEO_HARMONY_VERSION)) {
          if (method) {
            if (OLD_BRIDGE_FUNCTION.includes(method)) {
              const paramsStr = getQueryParams(data)
              return window.ingeekJSApi.common.handleEvent({
                url: `app://event/${method}${paramsStr ? `?${paramsStr}` : ''}`
              }, callback)
            } else {
              return method && window.ingeekJSApi.common[method](data, callback)
            }
          }
        }
        if (!compareVersion(appInfo.version, defaultMinVersion)) {
          console.warn(`当前版本过低，最低版本为${defaultMinVersion}`)
          return
        }
      }
      
    }
    if (appInfo.isAndroid && f.android) {
      return f.android();
    }
    if (appInfo.isIOS && f.ios) {
      return f.ios();
    }
  }
} 
